/**
 * This script is meant to be injected during the build process to set the OpenAI API key
 * in a way that doesn't expose it in the source code but makes it available at runtime.
 * 
 * Usage in build.sh:
 * 1. First build your React app
 * 2. Then use string replacement to inject the API key:
 *    sed -i "s/OPENAI_API_KEY_PLACEHOLDER/your-actual-api-key/g" build/static/js/openaiKeyLoader.*.js
 *    
 *    OR directly add a script tag in your index.html:
 *    <script>window.OPENAI_API_KEY = "your-actual-api-key";</script>
 * 
 * This script will set the API key as window.OPENAI_API_KEY which the ResumeEditor component will use.
 */

(function() {
  try {
    // First check if the key is already set via a script tag in index.html
    if (window.OPENAI_API_KEY && window.OPENAI_API_KEY !== "OPENAI_API_KEY_PLACEHOLDER") {
      const key = window.OPENAI_API_KEY;
      const maskedKey = key.slice(0, 3) + "..." + key.slice(-4);
      console.log(`OpenAI API key already set via script tag: ${maskedKey}`);
      return;
    }
    
    // Check for environment variables exposed via process.env (development) or window.__ENV (production)
    // Some hosting providers allow environment variables to be exposed via window.__ENV
    if (typeof window.__ENV !== 'undefined' && window.__ENV.OPENAI_API_KEY) {
      window.OPENAI_API_KEY = window.__ENV.OPENAI_API_KEY;
      const key = window.OPENAI_API_KEY;
      const maskedKey = key.slice(0, 3) + "..." + key.slice(-4);
      console.log(`OpenAI API key loaded from window.__ENV: ${maskedKey}`);
      return;
    }

    // If we reach here, try the placeholder that should be replaced during build
    // Note: "OPENAI_API_KEY_PLACEHOLDER" is the string that will be replaced during build
    const placeholder = "OPENAI_API_KEY_PLACEHOLDER";
    if (placeholder !== "OPENAI_API_KEY_PLACEHOLDER") {
      window.OPENAI_API_KEY = placeholder;
      const key = window.OPENAI_API_KEY;
      const maskedKey = key.slice(0, 3) + "..." + key.slice(-4);
      console.log(`OpenAI API key loaded from build-time injection: ${maskedKey}`);
      return;
    }
    
    // If we reach here, the key was not set
    console.warn("OpenAI API key placeholder was not replaced during build. Please add your API key to your production build via one of these methods:");
    console.warn("1. Add a <script>window.OPENAI_API_KEY = 'your-key';</script> tag to your index.html");
    console.warn("2. Modify your build process to replace OPENAI_API_KEY_PLACEHOLDER with your actual key");
    console.warn("3. Use environment variables exposed via window.__ENV");
  } catch (error) {
    console.error("Error setting OpenAI API key:", error);
  }
})(); 